import { useEffect, useRef, useState } from 'react';
import parse from 'html-react-parser';
import { Modal } from 'react-bootstrap';

import { Parameter } from '../../classess/parameter/parameter';
import { ParameterDetail } from '../../classess/parameter/parameterDetail';

import {
    getProcessButtons, isUndNullEmp, getLanguageObj, getResponse, getRolesType, handleResponseMessageAsync, settings,
    styles
} from '../../helpers/main';
import { GlobalFormats } from '../../classess/main/globalFormats';
import { Device } from '../../classess/device/device';
import { ParameterService } from '../../services/parameters/ParameterService';

const currentMethod = 'ParameterDetailAddEditDetail';

export default function ParameterDetailAddEditDetail({
    modalObj = {
        $: {},
        type: 0,
        auth: {},
        showModal: false,
        languageObj: GlobalFormats?.getClass(getLanguageObj({ subMethod: currentMethod })?.result),
        dtParameterDetailsId: '',
        dtParameterDetailsRowId: 0,
        parameter: Parameter?.getClass({}, false),
        parameterDetail: ParameterDetail?.class({}, false),
        brdFieldViews: {
            status: {
                label: '',
                badget: '',
            },
            scheduledDate: {
                date: '',
                time: ''
            },
            executionDate: {
                date: '',
                time: ''
            },
            description: '',
        },
        devices: [Device?.getClass({}, false)],
        setDevices: () => { },
        userRoles: getRolesType(),
    },
    setModalObj = {},
}) {
    //#region variables
    const isMount = useRef(false);
    const [process, setProcess] = useState({
        showLoading: false,
        save: false,
    });
    const [errors, setErrors] = useState({
        device: '',
        observations: '',
    });

    const { icons, images, labels, messages } = settings;

    const [dataFormLength] = useState(ParameterDetail.minMaxLength(false));
    const [collapseButtonsStatus, setCollapseButtonsStatus] = useState({ device: false, logIn: false, teamViewver: false });
    const parameterSections = {
        device: {
            show: false,
            title: '',
            detailsShow: {
                mark: false,
                model: false,
                serial: false,
                description: false,
                primaryIp: false,
                primaryMacAddress: false,
                primaryDNS: false,
                secondaryIp: false,
                secondaryMacAddress: false,
                secondaryDNS: false,
            },
        },
        logIn: {
            show: false,
            title: '',
            detailsShow: {
                adminUser: false,
                adminPassword: false,
                domainUser: false,
            },
        },
        teamViewver: {
            show: false,
            title: '',
            detailsShow: {
                teamViewverId: false,
                teamViewverPassword: false,
            },
        },
        observations: {
            show: false,
        }
    };
    const [parameterSectionShow, setParameterSectionShow] = useState(parameterSections);
    const controls = {
        buttons: {
            back: {
                defaultClass: 'btn btn-outline-secondary shadow-sm font-weight-bold px-4',
                id: 'btnModalBack',
            },
            save: {
                defaultClass: 'btn btn-primary shadow-sm font-weight-bold mx-1 px-4 mx-1',
                id: 'btnModalSave',
            },
            closeModal: {
                defaultClass: 'close border-0 bg-transparent',
                id: 'btnModalClose',
            },
        },
        collapse: {
            id: 'mainModal',
            device: {
                id: 'collapseModalDevice',
                button: {
                    id: 'collapseModalDeviceButton',
                    defaultClass: 'btn btn-light btn-block text-left d-flex align-items-center justify-content-between shadow-sm border-0 py-3',
                },
            },
            logIn: {
                id: 'collapseModalLogIn',
                button: {
                    id: 'collapseModalDeviceLogIn',
                    defaultClass: 'btn btn-light btn-block text-left d-flex align-items-center justify-content-between shadow-sm border-0 py-3',
                },
            },
            teamViewver: {
                id: 'collapseModalTeamViewver',
                button: {
                    id: 'collapseModalDeviceTeamViewver',
                    defaultClass: 'btn btn-light btn-block text-left d-flex align-items-center justify-content-between shadow-sm border-0 py-3',
                },
            },
        },
        icons: {
            save: {
                id: 'iconModalSave',
                defaultClass: icons?.fasFa?.save,
            },
            back: {
                id: 'iconModalBack',
                defaultClass: icons?.fasFa?.arrowCircleLeft,
            },
        },
        inputs: {
            adminUser: {
                id: 'inputModalAdminUser',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            adminPassword: {
                id: 'inputModalAdminPassword',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            description: {
                id: 'inputModalDescription',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            domainUser: {
                id: 'inputModalDomainUser',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            mark: {
                id: 'inputModalMark',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            model: {
                id: 'inputModalModel',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            password: {
                id: 'inputModalPassword',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            primaryDNS: {
                id: 'inputModalPrimaryDNS',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            primaryIp: {
                id: 'inputModalPrimaryIp',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            primaryMacAddress: {
                id: 'inputModalPrimaryMacAddress',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            secondaryDNS: {
                id: 'inputModalSecondaryDNS',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            secondaryIp: {
                id: 'inputModalSecondaryIp',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            secondaryMacAddress: {
                id: 'inputModalSecondaryMacAddress',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            serial: {
                id: 'inputModalSerial',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            teamViewverId: {
                id: 'inputModalTeamViewverId',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
            teamViewverPassword: {
                id: 'inputModalTeamViewverPassword',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            },
        },
        pickers: {
        },
        selects: {
            devices: {
                id: 'selModalDevices',
                defaultClass: 'custom-select bg-light border-0 shadow-sm text-dark',
            },
        },
        spiners: {
            save: {
                id: 'spModalSave',
                defaultClass: '',
            }
        },
        textAreas: {
            observations: {
                id: 'txtAreaModalObservations',
                defaultClass: 'form-control bg-light border-0 shadow-sm text-dark',
            }
        }
    };
    const cbDevice = useRef(null);
    const cbLogin = useRef(null);
    const cbTeamViewver = useRef(null);
    //#endregion variables

    //#region methods
    //#region parameterdetails
    //#region parameterdetails
    const addParameterDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'addParameterDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region collapse (check opened)
            if (collapseButtonsStatus?.device) {
                // modalObj?.$(`#${controls?.collapse?.device?.button?.id}`).trigger('click');
                cbDevice?.current?.click();
            } else if (collapseButtonsStatus?.logIn) {
                // modalObj?.$(`#${controls?.collapse?.logIn?.button?.id}`).trigger('click');
                cbLogin?.current?.click();
            } else if (collapseButtonsStatus?.teamViewver) {
                // modalObj?.$(`#${controls?.collapse?.teamViewver?.button?.id}`).trigger('click');
                cbTeamViewver?.current?.click();
            }
            //#endregion collapse (check opened)

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region parameterdetail (create)
            response = await ParameterService.addDetailAsync({
                auth: modalObj?.auth,
                parameterDetail: modalObj?.parameterDetail,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const parameterDetailsResult = response?.result?.parameterDetail || {};
            const devicesResult = response?.result?.devices || [];

            modalObj.devices = devicesResult;
            modalObj.parameterDetail = parameterDetailsResult;

            modalObj?.setDevices(devicesResult);
            //#endregion parameterdetail (create)

            //#region datatable add
            //#region variables
            const modelParameterDetail = ParameterDetail?.class(parameterDetailsResult, false);
            const modelDevice = devicesResult?.find(({ id, }) => id === (parameterDetailsResult?.deviceId || 0)) || Device?.getClass({}, false);
            //#endregion variables

            modalObj?.$(`#${modalObj.dtParameterDetailsId}`).DataTable().row.add([
                modelDevice?.name || '',
                modelParameterDetail?.description || '',
                getProcessButtons({
                    id: modelParameterDetail.id,
                    description: modelDevice?.name || '',
                    showDetails: true,
                    labelDetails: labels?.details?.[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelDelete: labels?.delete?.[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    showEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable add

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));
            if (response.isSuccess && !response.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    setShowData: modalObj?.setShowData,
                    showDataValue: response?.isSuccess,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }

    const editParameterDetail = async ({
        e = undefined,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'editParameterDetail';
        let response = getResponse({ type: 0 });
        try {
            e?.preventDefault?.();

            //#region collapse (check opened)
            if (collapseButtonsStatus?.device) {
                // modalObj?.$(`#${controls?.collapse?.device?.button?.id}`).trigger('click');
                cbDevice?.current?.click();
            } else if (collapseButtonsStatus?.logIn) {
                // modalObj?.$(`#${controls?.collapse?.logIn?.button?.id}`).trigger('click');
                cbLogin?.current?.click();
            } else if (collapseButtonsStatus?.teamViewver) {
                // modalObj?.$(`#${controls?.collapse?.teamViewver?.button?.id}`).trigger('click');
                cbTeamViewver?.current?.click();
            }
            //#endregion collapse (check opened)

            //#region errors default / validate data
            response = setErrorsDefault({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;

            response = validateFormData({ subMethod: currentMethod, });
            if (!response?.isSuccess || response?.isWarning) return;
            //#endregion errors default / validate data

            setProcess(prev => ({ ...prev, save: true, showLoading: true }));

            //#region parameterdetail (update)
            response = await ParameterService.updateDetail({
                auth: modalObj?.auth,
                id: modalObj?.parameterDetail?.id,
                parameterDetail: modalObj?.parameterDetail,
                languageId: modalObj?.languageObj?.id,
                subMethod: currentMethod,
            });
            if (!response?.isSuccess || response?.isWarning) return;

            const parameterDetailsResult = response?.result?.parameterDetail || modalObj?.parameterDetail || {};
            modalObj.parameterDetail = parameterDetailsResult;
            //#endregion parameterdetail (update)

            //#region datatable update
            //#region variables
            const modelParameterDetail = ParameterDetail?.class(parameterDetailsResult, false);
            const modelDevice = modalObj?.devices?.find(({ id, }) => id === (parameterDetailsResult?.deviceId || 0)) || Device?.getClass({}, false);
            //#endregion variables

            modalObj?.$(`#${modalObj.dtParameterDetailsId}`).DataTable().row(modalObj?.dtParameterDetailsRowId).data([
                modelDevice?.name || '',
                modelParameterDetail?.description || '',
                getProcessButtons({
                    id: modelParameterDetail.id,
                    description: modelDevice?.name || '',
                    showDetails: true,
                    labelDetails: labels?.details?.[modalObj?.languageObj?.id],
                    enabledDetails: true,
                    showDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelDelete: labels?.delete?.[modalObj?.languageObj?.id],
                    enabledDelete: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    showEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    labelEdit: labels?.edit?.[modalObj?.languageObj?.id],
                    enabledEdit: modalObj?.userRoles?.isAdmin || modalObj?.userRoles?.isAnalyst,
                    processButtons: [],
                })?.result,
            ])?.draw(true);
            //#endregion datatable update

            response.msgText = `${messages?.processCompletedSuccessfully?.[modalObj?.languageObj?.id]}.`;
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        } finally {
            if (!isMount.current) return;
            setProcess(prev => ({ ...prev, save: false, showLoading: false }));
            if (response.isSuccess && !response.isWarning) setDefaultValue({ closeModal: true, subMethod: currentMethod });
            // CSN:
            if (!response?.isSuccess || response?.isWarning || response?.msgText !== '' || response?.msgTextHtml !== '') {
                await handleResponseMessageAsync({
                    response,
                    currentMethod,
                    auth: modalObj?.auth,
                    languageId: modalObj?.languageObj?.id
                });
            }
        }
    }
    //#endregion parameterdetails

    //#region others
    const getData = async ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'getData';
        let response = getResponse({ type: 0 });
        try {
            //#region variables
            let parameterSectionsObj = parameterSections;
            //#endregion variables

            //#region show section (set)
            if (modalObj?.type === 2) {
                parameterSectionsObj = {
                    ...parameterSectionsObj,
                    device: {
                        ...parameterSectionsObj?.device,
                        detailsShow: {
                            ...parameterSectionsObj?.device?.detailsShow,
                            mark: !isUndNullEmp({ data: modalObj?.parameterDetail?.mark, subMethod: currentMethod })?.result,
                            model: !isUndNullEmp({ data: modalObj?.parameterDetail?.model, subMethod: currentMethod })?.result,
                            serial: !isUndNullEmp({ data: modalObj?.parameterDetail?.serial, subMethod: currentMethod })?.result,
                            description: !isUndNullEmp({ data: modalObj?.parameterDetail?.description, subMethod: currentMethod })?.result,
                            primaryIp: !isUndNullEmp({ data: modalObj?.parameterDetail?.primaryIp, subMethod: currentMethod })?.result,
                            primaryMacAddress: !isUndNullEmp({ data: modalObj?.parameterDetail?.primaryMacAddress, subMethod: currentMethod })?.result,
                            primaryDNS: !isUndNullEmp({ data: modalObj?.parameterDetail?.primaryDNS, subMethod: currentMethod })?.result,
                            secondaryIp: !isUndNullEmp({ data: modalObj?.parameterDetail?.secondaryIp, subMethod: currentMethod })?.result,
                            secondaryMacAddress: !isUndNullEmp({ data: modalObj?.parameterDetail?.secondaryMacAddress, subMethod: currentMethod })?.result,
                            secondaryDNS: !isUndNullEmp({ data: modalObj?.parameterDetail?.secondaryDNS, subMethod: currentMethod })?.result
                        },
                    },
                    logIn: {
                        ...parameterSectionsObj?.logIn,
                        detailsShow: {
                            ...parameterSectionsObj?.logIn?.detailsShow,
                            adminUser: !isUndNullEmp({ data: modalObj?.parameterDetail?.adminUser, subMethod: currentMethod })?.result,
                            adminPassword: !isUndNullEmp({ data: modalObj?.parameterDetail?.adminPassword, subMethod: currentMethod })?.result,
                            domainUser: !isUndNullEmp({ data: modalObj?.parameterDetail?.domainUser, subMethod: currentMethod })?.result,
                        }
                    },
                    teamViewver: {
                        ...parameterSectionsObj?.teamViewver,
                        detailsShow: {
                            ...parameterSectionsObj?.teamViewver?.detailsShow,
                            teamViewverId: !isUndNullEmp({ data: modalObj?.parameterDetail?.teamViewverId, subMethod: currentMethod })?.result,
                            teamViewverPassword: !isUndNullEmp({ data: modalObj?.parameterDetail?.teamViewverPassword, subMethod: currentMethod })?.result,
                        },
                    },
                    observations: {
                        ...parameterSectionsObj?.observations,
                        show: !isUndNullEmp({ data: modalObj?.parameterDetail?.observations, subMethod: currentMethod })?.result,
                    }
                };
                parameterSectionsObj = {
                    ...parameterSectionsObj,
                    device: {
                        ...parameterSectionsObj?.device,
                        show: (parameterSectionsObj?.device?.detailsShow?.mark ||
                            parameterSectionsObj?.device?.detailsShow?.model ||
                            parameterSectionsObj?.device?.detailsShow?.serial ||
                            parameterSectionsObj?.device?.detailsShow?.description ||
                            parameterSectionsObj?.device?.detailsShow?.primaryIp ||
                            parameterSectionsObj?.device?.detailsShow?.primaryMacAddress ||
                            parameterSectionsObj?.device?.detailsShow?.primaryDNS ||
                            parameterSectionsObj?.device?.detailsShow?.secondaryIp ||
                            parameterSectionsObj?.device?.detailsShow?.secondaryMacAddress ||
                            parameterSectionsObj?.device?.detailsShow?.secondaryDNS
                        ),
                    },
                    logIn: {
                        ...parameterSectionsObj?.logIn,
                        show: (parameterSectionsObj?.logIn?.detailsShow?.adminPassword ||
                            parameterSectionsObj?.logIn?.detailsShow?.adminUser ||
                            parameterSectionsObj?.logIn?.detailsShow?.domainUser
                        ),
                    },
                    teamViewver: {
                        ...parameterSectionsObj?.teamViewver,
                        show: (parameterSectionsObj?.teamViewver?.detailsShow?.teamViewverId ||
                            parameterSectionsObj?.teamViewver?.detailsShow?.teamViewverPassword
                        ),
                    },
                };
                parameterSectionsObj = {
                    ...parameterSectionsObj,
                    device: {
                        ...parameterSectionsObj?.device,
                        title: parameterSectionsObj?.device?.show ?
                            modalObj?.devices?.filter(({ id, }) => id === modalObj?.parameterDetail?.deviceId)[0]?.name || '' : '',
                    }
                }
                if (isMount.current) setParameterSectionShow(parameterSectionsObj);
            }
            //#endregion show section (set)
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setDefaultValue = ({
        closeModal = false,
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setDefaultValue';
        let response = getResponse({ type: 0 });
        try {
            if (closeModal) {
                setModalObj(prev => ({
                    ...prev,
                    showModal: false,
                    type: 0,
                }));
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response?.msgText);
        }
    }

    const validateFormData = ({
        subMethod = ''
    } = {}) => {
        const currentMethod = 'validateFormData';
        let response = getResponse({ type: 0 });
        try {
            const requiredMsg = `${messages?.thisFieldRequired?.[modalObj?.languageObj?.id]}.`;

            if (isUndNullEmp({ data: modalObj?.parameterDetail?.deviceId, subMethod: currentMethod })?.result ||
                modalObj?.parameterDetail?.deviceId <= 0) {
                setErrors(prev => ({ ...prev, device: requiredMsg }));
                response = getResponse({ type: 1 });
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setErrorsDefault = ({
        subMethod = '',
    } = {}) => {
        const currentMethod = 'setErrorsDefault';
        let response = getResponse({ type: 0 });
        try {
            setErrors({
                device: '',
                observations: '',
            });
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
        }
        return response;
    }

    const setCollapseButtons = ({
        e = undefined,
        subMethod = ''
    } = {}) => {
        const currentMethod = 'setCollapseButtons';
        let response = getResponse({ type: 0 });
        try {
            if (isUndNullEmp({ data: e, subMethod: currentMethod })?.result) return;
            const btnId = e?.currentTarget?.id;
            switch (btnId) {
                case controls?.collapse?.device?.button?.id:
                    modalObj?.$(`#${controls?.collapse?.device?.id}`).collapse('toggle');
                    if (isMount.current) {
                        setCollapseButtonsStatus({
                            device: !collapseButtonsStatus?.device,
                            logIn: false,
                            teamViewver: false
                        });
                    }
                    break;
                case controls?.collapse?.logIn?.button?.id:
                    modalObj?.$(`#${controls?.collapse?.logIn?.id}`).collapse('toggle');
                    if (isMount.current) {
                        setCollapseButtonsStatus({
                            device: false,
                            logIn: !collapseButtonsStatus?.logIn,
                            teamViewver: false,
                        });
                    }
                    break;
                case controls?.collapse?.teamViewver?.button?.id:
                    modalObj?.$(`#${controls?.collapse?.teamViewver?.id}`).collapse('toggle');
                    if (isMount.current) {
                        setCollapseButtonsStatus({
                            device: false,
                            logIn: false,
                            teamViewver: !collapseButtonsStatus?.teamViewver,
                        });
                    }
                    break;
                default:
                    break;
            }
        } catch (ex) {
            response = getResponse({ type: -1 });
            response.msgText = `Method: ${currentMethod}<br/>`;
            if (!isUndNullEmp({ data: subMethod, subMethod: currentMethod })?.result) {
                response.msgText += `Sub method: ${subMethod}<br/>`;
            }
            response.msgText += `Error: ${ex?.message}<br/>`;
            console.error(response.msgText);
        }
    }

    useEffect(() => {
        isMount.current = true;
        getData({ subMethod: 'form - onLoad' });
        return () => { isMount.current = false; };
    }, []);// eslint-disable-line react-hooks/exhaustive-deps
    //#endregion others
    //#endregion methods

    return (
        <Modal backdrop='static' show={modalObj?.showModal} centered size=''>
            <Modal.Header className='border-bottom-0 pt-4 px-4 bg-white'>
                <Modal.Title className='d-flex align-items-center w-100'>
                    <div className='bg-light p-2 rounded-circle mr-3 shadow-sm'
                        style={{ width: '45px', height: '45px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <img alt='parameters' src={images?.icons?.parameters} style={{ ...styles?.cardHeaderLogo }} />
                    </div>
                    <div className='d-flex flex-column'>
                        <span className='h5 mb-0 font-weight-bold text-dark'>{labels?.parameterDetail?.[modalObj?.languageObj?.id]}</span>
                        <div className='d-flex align-items-center mt-1'>
                            <span className={`badge badge-pill py-1 px-2 text-uppercase ${modalObj?.type === 0 ? 'badge-info' : modalObj?.type === 1 ? 'badge-warning text-dark' : 'badge-secondary'}`} style={settings?.html?.badges?.micro}>
                                {modalObj?.type === 0 ? labels?.add?.[modalObj?.languageObj?.id] :
                                    modalObj?.type === 1 ? labels?.edit?.[modalObj?.languageObj?.id] :
                                        labels?.detail?.[modalObj?.languageObj?.id]}
                            </span>
                        </div>
                    </div>
                </Modal.Title>
                <button id={controls?.buttons?.closeModal?.id}
                    className={controls?.buttons?.closeModal?.defaultClass}
                    disabled={process.save || process.showLoading}
                    aria-label='Close'
                    style={{ fontSize: '1.5rem', marginTop: '-15px' }}
                    onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.closeModal?.id })}>
                    <span aria-hidden='true'>&times;</span>
                </button>
            </Modal.Header>

            <form onSubmit={(e) => modalObj?.type === 0 ?
                addParameterDetail({ e: e, subMethod: 'form - onSubmit', }) :
                modalObj?.type === 1 ?
                    editParameterDetail({ e: e, subMethod: 'form - onSubmit', }) :
                    e?.preventDefault()}>

                <Modal.Body className='p-0'>
                    <div className='card-body p-4'>
                        {modalObj?.type !== 2 ?
                            <div className='row'>
                                <div className='col-12 mb-4'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={icons?.fasFa?.list} /> {labels?.device?.[modalObj?.languageObj?.id]}
                                        </small>
                                        <div className='input-group'>
                                            <select id={controls?.selects?.devices?.id}
                                                disabled={process?.save || process?.showLoading || (modalObj?.type !== 0 && modalObj?.type !== 1)}
                                                className={controls?.selects?.devices?.defaultClass}
                                                style={{ borderRadius: '5px' }}
                                                value={!isUndNullEmp({ data: modalObj?.parameterDetail?.deviceId, subMethod: controls?.selects?.devices?.id, })?.result ?
                                                    modalObj?.parameterDetail?.deviceId : 0
                                                }
                                                onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, deviceId: parseInt(e?.currentTarget?.value) } })}
                                                onFocus={() => setErrors(prev => ({ ...prev, device: '' }))}
                                                title={labels?.device?.[modalObj?.languageObj?.id]}>
                                                <option key='nothing' value='0'>{messages?.selectDevice?.[modalObj?.languageObj?.id]}</option>
                                                {modalObj?.devices?.map((device) =>
                                                    <option key={device.id} value={device.id}>{device?.name || 'undefined'}</option>
                                                )}
                                            </select>
                                        </div>
                                        <div className='form-text' style={styles?.inputMsgAlert}>{parse(errors?.device || '')}</div>
                                    </div>
                                </div>

                                <div className='col-12' id={controls?.collapse?.id}>
                                    {/* SECTION: DEVICE DETAILS */}
                                    <div className='mb-3'>
                                        <button className={controls?.collapse?.device?.button?.defaultClass}
                                            id={controls?.collapse?.device?.button?.id}
                                            ref={cbDevice}
                                            type='button'
                                            disabled={process.save || process.showLoading}
                                            style={{ borderRadius: '12px' }}
                                            onClick={(e) => setCollapseButtons({ e: e, subMethod: e?.currentTarget?.id })}>
                                            <span className='font-weight-bold'><i className={`${icons?.fasFa?.desktop} mr-2 text-primary`} /> {labels?.device?.[modalObj?.languageObj?.id]}</span>
                                            <i className={!collapseButtonsStatus?.device ? icons?.fasFa?.angleDoubleDown : icons?.fasFa?.angleDoubleUp} />
                                        </button>
                                        <div id={controls?.collapse?.device?.id} className='collapse mt-2 px-2' data-parent={`#${controls?.collapse?.id}`}>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.mark?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.mark?.id} className={controls?.inputs?.mark?.defaultClass} maxLength={dataFormLength?.max?.mark} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.mark || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, mark: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.model?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.model?.id} className={controls?.inputs?.model?.defaultClass} maxLength={dataFormLength?.max?.model} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.model || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, model: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.serial?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.serial?.id} className={controls?.inputs?.serial?.defaultClass} maxLength={dataFormLength?.max?.serial} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.serial || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, serial: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.description?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.description?.id} className={controls?.inputs?.description?.defaultClass} maxLength={dataFormLength?.max?.description} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.description || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, description: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.primaryIp?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.primaryIp?.id} className={controls?.inputs?.primaryIp?.defaultClass} maxLength={dataFormLength?.max?.primaryIp} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.primaryIp || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, primaryIp: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.primaryMacAddress?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.primaryMacAddress?.id} className={controls?.inputs?.primaryMacAddress?.defaultClass} maxLength={dataFormLength?.max?.primaryMacAddress} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.primaryMacAddress || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, primaryMacAddress: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.primaryDNS?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.primaryDNS?.id} className={controls?.inputs?.primaryDNS?.defaultClass} maxLength={dataFormLength?.max?.primaryDNS} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.primaryDNS || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, primaryDNS: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.secondaryIp?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.secondaryIp?.id} className={controls?.inputs?.secondaryIp?.defaultClass} maxLength={dataFormLength?.max?.secondaryIp} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.secondaryIp || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, secondaryIp: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.secondaryMacAddress?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.secondaryMacAddress?.id} className={controls?.inputs?.secondaryMacAddress?.defaultClass} maxLength={dataFormLength?.max?.secondaryMacAddress} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.secondaryMacAddress || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, secondaryMacAddress: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.secondaryDNS?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.secondaryDNS?.id} className={controls?.inputs?.secondaryDNS?.defaultClass} maxLength={dataFormLength?.max?.secondaryDNS} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.secondaryDNS || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, secondaryDNS: e?.target?.value } })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* SECTION: LOGIN DETAILS */}
                                    <div className='mb-3'>
                                        <button className={controls?.collapse?.logIn?.button?.defaultClass}
                                            id={controls?.collapse?.logIn?.button?.id}
                                            ref={cbLogin}
                                            type='button'
                                            disabled={process.save || process.showLoading}
                                            style={{ borderRadius: '12px' }}
                                            onClick={(e) => setCollapseButtons({ e: e, subMethod: e?.currentTarget?.id })}>
                                            <span className='font-weight-bold'><i className={`${icons?.fasFa?.idCard} mr-2 text-success`} /> {labels?.login?.[modalObj?.languageObj?.id]}</span>
                                            <i className={!collapseButtonsStatus?.logIn ? icons?.fasFa?.angleDoubleDown : icons?.fasFa?.angleDoubleUp} />
                                        </button>
                                        <div id={controls?.collapse?.logIn?.id} className='collapse mt-2 px-2' data-parent={`#${controls?.collapse?.id}`}>
                                            <div className='row'>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.user?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.adminUser?.id} className={controls?.inputs?.adminUser?.defaultClass} maxLength={dataFormLength?.max?.adminUser} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.adminUser || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, adminUser: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.password?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.adminPassword?.id} className={controls?.inputs?.adminPassword?.defaultClass} maxLength={dataFormLength?.max?.adminPassword} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.adminPassword || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, adminPassword: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-4 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.domain?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.domainUser?.id} className={controls?.inputs?.domainUser?.defaultClass} maxLength={dataFormLength?.max?.domainUser} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.domainUser || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, domainUser: e?.target?.value } })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                    {/* SECTION: TEAMVIEWVER DETAILS */}
                                    <div className='mb-3'>
                                        <button className={controls?.collapse?.teamViewver?.button?.defaultClass}
                                            id={controls?.collapse?.teamViewver?.button?.id}
                                            ref={cbTeamViewver}
                                            type='button'
                                            disabled={process.save || process.showLoading}
                                            style={{ borderRadius: '12px' }}
                                            onClick={(e) => setCollapseButtons({ e: e, subMethod: e?.currentTarget?.id })}>
                                            <span className='font-weight-bold'><i className={`${icons?.fasFa?.users} mr-2 text-info`} /> TeamViewer</span>
                                            <i className={!collapseButtonsStatus?.teamViewver ? icons?.fasFa?.angleDoubleDown : icons?.fasFa?.angleDoubleUp} />
                                        </button>
                                        <div id={controls?.collapse?.teamViewver?.id} className='collapse mt-2 px-2' data-parent={`#${controls?.collapse?.id}`}>
                                            <div className='row'>
                                                <div className='col-md-6 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.id?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.teamViewverId?.id} className={controls?.inputs?.teamViewverId?.defaultClass} maxLength={dataFormLength?.max?.teamViewverId} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.teamViewverId || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, teamViewverId: e?.target?.value } })} />
                                                </div>
                                                <div className='col-md-6 mb-3'>
                                                    <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.password?.[modalObj?.languageObj?.id]}</small>
                                                    <input id={controls?.inputs?.teamViewverPassword?.id} className={controls?.inputs?.teamViewverPassword?.defaultClass} maxLength={dataFormLength?.max?.teamViewverPassword} readOnly={process.save || process.showLoading}
                                                        value={modalObj?.parameterDetail?.teamViewverPassword || ''} onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, teamViewverPassword: e?.target?.value } })} />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div className='col-12 mt-2'>
                                    <div className='form-group'>
                                        <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>
                                            <i className={`${icons?.fasFa?.edit}`} /> {labels?.observations?.[modalObj?.languageObj?.id]}
                                        </small>
                                        {/* <small className={settings?.html?.labels?.mutedUpperFontWeightBoldDblockMb2}>{labels?.observations?.[modalObj?.languageObj?.id]}</small> */}
                                        <textarea id={controls?.textAreas?.observations?.id} className={controls?.textAreas?.observations?.defaultClass} rows={3} maxLength={dataFormLength?.max?.observations} readOnly={process.save || process.showLoading}
                                            placeholder={labels?.observations?.[modalObj?.languageObj?.id]} value={modalObj?.parameterDetail?.observations || ''}
                                            onChange={(e) => setModalObj({ ...modalObj, parameterDetail: { ...modalObj?.parameterDetail, observations: e?.target?.value } })} />
                                    </div>
                                </div>
                            </div>
                            :
                            /* DETAIL MODE (Type 2) */
                            <div className='row'>
                                {parameterSectionShow?.device?.show && (
                                    <div className='col-12 mb-4'>
                                        <div className='rounded bg-light border-left border-primary shadow-sm p-4'>
                                            <h6 className='font-weight-bold text-primary mb-3 d-flex align-items-center'>
                                                <i className={icons?.fasFa?.desktop + ' mr-2'} /> {parameterSectionShow?.device?.title}
                                            </h6>
                                            <div className='row'>
                                                {parameterSectionShow?.device?.detailsShow?.mark && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.mark?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.mark}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.model && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.model?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.model}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.serial && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.serial?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.serial}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.description && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.description?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.description}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.primaryIp && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.primaryIp?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.primaryIp}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.primaryMacAddress && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.primaryMacAddress?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.primaryMacAddress}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.primaryDNS && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.primaryDNS?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.primaryDNS}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.secondaryIp && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.secondaryIp?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.secondaryIp}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.secondaryMacAddress && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.secondaryMacAddress?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.secondaryMacAddress}</span></div>}
                                                {parameterSectionShow?.device?.detailsShow?.secondaryDNS && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.secondaryDNS?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.secondaryDNS}</span></div>}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {parameterSectionShow?.logIn?.show && (
                                    <div className='col-12 mb-4'>
                                        <div className='rounded bg-light border-left border-success shadow-sm p-4'>
                                            <h6 className='font-weight-bold text-success mb-3 d-flex align-items-center'>
                                                <i className={icons?.fasFa?.idCard + ' mr-2'} /> {labels?.login?.[modalObj?.languageObj?.id]}
                                            </h6>
                                            <div className='row'>
                                                {parameterSectionShow?.logIn?.detailsShow?.adminUser && <div className='col-md-12 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.user?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.adminUser}</span></div>}
                                                {parameterSectionShow?.logIn?.detailsShow?.adminPassword && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.password?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.adminPassword}</span></div>}
                                                {parameterSectionShow?.logIn?.detailsShow?.domainUser && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.domain?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.domainUser}</span></div>}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {parameterSectionShow?.teamViewver?.show && (
                                    <div className='col-12 mb-4'>
                                        <div className='rounded bg-light border-left border-info shadow-sm p-4'>
                                            <h6 className='font-weight-bold text-info mb-3 d-flex align-items-center'>
                                                <i className={icons?.fasFa?.users + ' mr-2'} /> TeamViewer
                                            </h6>
                                            <div className='row'>
                                                {parameterSectionShow?.teamViewver?.detailsShow?.teamViewverId && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.id?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.teamViewverId}</span></div>}
                                                {parameterSectionShow?.teamViewver?.detailsShow?.teamViewverPassword && <div className='col-md-6 mb-2'><span className='text-muted' style={settings?.html?.labels?.detailMicro}>{labels?.password?.[modalObj?.languageObj?.id]}:</span> <span className='font-weight-bold ml-2 text-dark'>{modalObj?.parameterDetail?.teamViewverPassword}</span></div>}
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {parameterSectionShow?.observations?.show && (
                                    <div className='col-12 mb-2'>
                                        <div className='rounded bg-light border-left border-secondary shadow-sm p-4'>
                                            <h6 className='font-weight-bold text-secondary mb-3 d-flex align-items-center'>
                                                <i className={icons?.fasFa?.commentDots + ' mr-2'} /> {labels?.observations?.[modalObj?.languageObj?.id]}
                                            </h6>
                                            <div className='text-dark font-italic'>{modalObj?.parameterDetail?.observations}</div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        }
                    </div>
                </Modal.Body>

                <Modal.Footer className='border-top-0 pb-4 pt-0 d-flex justify-content-center bg-white rounded-bottom'>
                    {modalObj?.type !== 2 && (
                        <button id={controls?.buttons?.save?.id} type='submit' className={controls?.buttons?.save?.defaultClass} disabled={process.save || process.showLoading}>
                            {process.save || process.showLoading ? (
                                <span className={settings?.react?.html?.spinner?.borderSm} role='status' aria-hidden='true'></span>
                            ) : (
                                <i className={icons?.fasFa?.save + ' mr-2'} />
                            )} {labels?.save?.[modalObj?.languageObj?.id]}
                        </button>
                    )}
                    <button id={controls?.buttons?.back?.id} type='button' className={controls?.buttons?.back?.defaultClass} disabled={process.save || process.showLoading}
                        onClick={() => setDefaultValue({ closeModal: true, subMethod: controls?.buttons?.back?.id })}>
                        <i className={icons?.fasFa?.arrowCircleLeft + ' mr-2'} /> {labels?.back?.[modalObj?.languageObj?.id]}
                    </button>
                </Modal.Footer>
            </form>
        </Modal>
    );
}